import(/* webpackMode: "eager", webpackExports: ["GrantContentSwitcher"] */ "/vercel/path0/components/Funding/GrantContentSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProposalFeed"] */ "/vercel/path0/components/Funding/ProposalFeed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProposalSortAndFilters"] */ "/vercel/path0/components/Funding/ProposalSortAndFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FundraiseProvider"] */ "/vercel/path0/contexts/FundraiseContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
